/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_COMPANY_PROFILE_HOURS
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted hours of operation section from CompanyProfileForm.tsx.
 * Fixed incorrect relative import paths and implicit any types.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/company-profile/components/HoursOfOperation.tsx
 */
import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import timeZones from "../../../../utils/timezones";

// [2025-12-29] Parameter type fix
const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const TIMES = ["12 AM", "1 AM", "2 AM", "3 AM", "4 AM", "5 AM", "6 AM", "7 AM", "8 AM", "9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM", "10 PM", "11 PM"];

export const HoursOfOperation: React.FC<{ formik: any }> = ({ formik }) => {
  return (
    <div className="mt-3">
      <Row className="align-items-center mb-3">
        <Col md={4}><Form.Label className="field-name mb-0">Time zone</Form.Label></Col>
        <Col md={8}>
          <Form.Select className="field-select" {...formik.getFieldProps("timeZone")}>
            <option value="">Select time zone</option>
            {/* [2025-12-29] Type fix: tz has value and label */}
            {timeZones.map((tz: { value: string; label: string }) => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center mb-3">
        <Col md="auto"><span className="hours-section-heading">Days:</span></Col>
        <Col md={4}><Form.Select className="field-select" {...formik.getFieldProps("fromDay")}>{DAYS.map(d => <option key={d}>{d}</option>)}</Form.Select></Col>
        <Col md="auto">To</Col>
        <Col md={4}><Form.Select className="field-select" {...formik.getFieldProps("toDay")}>{DAYS.map(d => <option key={d}>{d}</option>)}</Form.Select></Col>
      </Row>
      <Row className="align-items-center mb-3">
        <Col md="auto"><span className="hours-section-heading">Hours:</span></Col>
        <Col md={4}><Form.Select className="field-select" {...formik.getFieldProps("from")}>{TIMES.map(t => <option key={t}>{t}</option>)}</Form.Select></Col>
        <Col md="auto">To</Col>
        <Col md={4}><Form.Select className="field-select" {...formik.getFieldProps("to")}>{TIMES.map(t => <option key={t}>{t}</option>)}</Form.Select></Col>
      </Row>
    </div>
  );
};
